import React from "react";
import { AIMS_STATUS, ROLES } from "../../constants";
import TranscribeAvailable from "./TranscribeAvailable";
import TranscribeNotAvailable from "./TranscribeNotAvailable";

/**
 * Router for the "Transcribe meeting" feature. Decides availability once and
 * renders the matching flow:
 *
 * - Available (organizer / alternative host in an AiMS-eligible meeting):
 *   TranscribeAvailable owns the RTMS session lifecycle.
 * - Not available (everyone else): TranscribeNotAvailable.
 */
const Transcript = ({ aimsStatus, role, ...props }) => {
  const isAvailable =
    aimsStatus === AIMS_STATUS.TRANSCRIPT_AVAILABLE &&
    (role === ROLES.ORGANIZER || role === ROLES.ALTERNATIVE_HOST);

  return isAvailable ? (
    <TranscribeAvailable role={role} {...props} />
  ) : (
    <TranscribeNotAvailable />
  );
};

export default Transcript;
